import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReconfirmParams } from "../../../domain/entities/undelivered";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reconfirm = createAsyncThunk<
  void,
  ReconfirmParams,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.RECONFIRM, async (params, { extra }) => {
  await extra.undeliveredRepo.reconfirm(params);
});
